import * as SecondaryNav from 'components/secondary-nav'
import * as React from 'react'
import { useRailsContext } from 'components/rails-context'
import { TUser } from 'src/design-system'

export type RailsWinsSecondaryNavProps = {
  teamName: string
  user: TUser
}

export const RailsWinsSecondaryNav: React.VFC<RailsWinsSecondaryNavProps> = (
  props
) => {
  const { org } = useRailsContext()
  const { teamName, user } = props

  const basePath = `/users/${user.slug}/wins`

  return (
    <SecondaryNav.Root className="items-end md:justify-end pt-0">
      <SecondaryNav.Header className="mb-0">Wins</SecondaryNav.Header>
      <SecondaryNav.Body>
        <SecondaryNav.Tabs>
          {org && (
            <SecondaryNav.Tab href={`${basePath}/org`}>
              {org?.name}
            </SecondaryNav.Tab>
          )}
          {teamName && (
            <SecondaryNav.Tab href={`${basePath}/team`}>
              {teamName}
            </SecondaryNav.Tab>
          )}
          <SecondaryNav.Tab href={`${basePath}/received`}>
            Received
          </SecondaryNav.Tab>
          <SecondaryNav.Tab href={`${basePath}/given`}>Given</SecondaryNav.Tab>
        </SecondaryNav.Tabs>
      </SecondaryNav.Body>
    </SecondaryNav.Root>
  )
}
